import './Card.css';

export default function Card({
  children,
  variant = 'default',
  padding = 'md',
  className = '',
  style,
  ...props
}) {
  return (
    <div
      className={`card card--${variant} card--padding-${padding} ${className}`}
      style={style}
      {...props}
    >
      {children}
    </div>
  );
}

export function CardHeader({ children, className = '' }) {
  return (
    <div className={`card__header ${className}`}>
      {children}
    </div>
  );
}

export function CardTitle({ children, as: Tag = 'h3', className = '' }) {
  return (
    <Tag className={`card__title ${className}`}>
      {children}
    </Tag>
  );
}

export function CardDescription({ children, className = '' }) {
  return (
    <p className={`card__description ${className}`}>
      {children}
    </p>
  );
}

export function CardContent({ children, className = '' }) {
  return (
    <div className={`card__content ${className}`}>
      {children}
    </div>
  );
}

export function CardFooter({ children, className = '' }) {
  return (
    <div className={`card__footer ${className}`}>
      {children}
    </div>
  );
}
